import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Apiservice } from '../../../../../services/ApiService';

@Component({
  selector: 'app-edit-gate',
  templateUrl: './edit-gate.component.html',
  styleUrl: './edit-gate.component.scss'
})
export class EditGateComponent {

gateName: string = '';
gateKey: number = 1;
gatesArray: any = [];
selectedVenue: string = '';

constructor(private _http: HttpClient, private router:Router, private apiservice:Apiservice) {}

onGateNameChange(event: any) {
  this.gateName = event?.target?.value;
}

editGate() {
  if (this.gateKey !== undefined && this.gateKey >= 0 && this.gateKey < this.gatesArray.length) {
    const updatedGatesArray = [...this.gatesArray];
    updatedGatesArray[this.gateKey].value = this.gateName;

    this.gatesArray = updatedGatesArray;

    
    const gateNames = updatedGatesArray.map(gate => gate.value);

    const body = {
      venue: this.selectedVenue,
      gates: gateNames, 
    };

    this._http
      .post(
        'https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/gates',
        body
      )
      .subscribe({
        next: (data) => {
          this.gateName = '';
          this.router.navigate(['tools/gates']);
        },
        error: (error) => {
          
        },
      });
  } else {
    console.error('Invalid gateKey or gates array.');
  }
}


  ngOnInit() {
    const gate = history.state.gate;
    if (gate) {
      this.gateName = gate.value;
      this.gateKey = gate.key;
      this.gatesArray = history.state.gatesArray;
      this.selectedVenue = history.state.Selectedvenue;
    }
  }
}
